<template>
    <div class="pb-6 lg:pb-20">
        <BaseCard :card="data">
            <template #image>
                <div
                    class="flex h-[235px] flex-col justify-center overflow-hidden hover:cursor-zoom-in"
                    @click="zoomModal?.open()"
                >
                    <StoryblokImage
                        v-if="data.image"
                        :src="data.image.src"
                        :alt="data.image.alt"
                        sizes="274px md:501px"
                        :image-width="501"
                        :image-height="501"
                        class="h-[215px] object-contain"
                        :preload="index === 0"
                    />
                    <div
                        class="invisible absolute bottom-[15px] right-[18px] h-[40px] w-[40px] rounded-md bg-grind pl-[10px] pt-[10px] text-lg text-white lg:visible"
                    >
                        <Icon name="magnifying-glass" />
                    </div>
                </div>
            </template>
            <template #footer>
                <div
                    class="flex flex-1 flex-col items-stretch justify-center gap-4"
                >
                    <button
                        class="btn-secondary relative flex items-center justify-center"
                        :data-cy="
                            'add-sample-to-cart-button-' + data.product.id
                        "
                        :disabled="isInCart"
                        @click.prevent="$emit('add-to-cart', data.product)"
                    >
                        <span v-if="!isInCart"> Add to cart </span>

                        <span
                            v-else
                            class="relative flex w-full items-center justify-center"
                        >
                            <transition name="pop-icon">
                                <icon
                                    v-if="isInCart"
                                    name="check"
                                    class="absolute left-0 h-5 w-5"
                                ></icon>
                            </transition>
                            <span class="w-full text-center"
                                >Added to cart</span
                            >
                        </span>
                    </button>

                    <button
                        class="pb-2 pt-4 text-center text-grind underline hover:no-underline"
                        :class="{
                            'pointer-events-none no-underline opacity-50':
                                !data.modal,
                        }"
                        @click="contentsModal?.open()"
                    >
                        What's included
                    </button>
                </div>
            </template>
        </BaseCard>

        <Modal
            ref="zoomModal"
            :show-action-buttons="false"
            width-class="w-full lg:w-1/2"
        >
            <StoryblokImage
                v-if="data.image"
                :src="data.image.src"
                :alt="data.image.alt"
                sizes="310px md:734px"
                :image-width="734"
                :image-height="734"
                :preload="false"
            />
        </Modal>

        <Modal
            v-show="data.modal"
            ref="contentsModal"
            :show-action-buttons="false"
            width-class="w-full lg:w-1/2"
        >
            <WysiwygContent :content="data.modal" />
        </Modal>
    </div>
</template>

<script setup lang="ts">
import SamplePackCardType from '~/types/sample-pack/SamplePackCardType';
import Modal from '~/components/Modal.vue';
import { ref } from 'vue';
import BaseCard from '~/components/ui/BaseCard.vue';

defineProps<{
    data: SamplePackCardType;
    index: number;
    isInCart: boolean;
}>();

const zoomModal = ref<InstanceType<typeof Modal> | null>(null);
const contentsModal = ref<InstanceType<typeof Modal> | null>(null);

defineEmits(['add-to-cart']);
</script>

<style>
.pop-icon-enter-active {
    animation: pop-in 300ms ease-out;
}
.pop-icon-leave-active {
    transition: opacity 0.2s ease;
    opacity: 0;
}

@keyframes pop-in {
    0% {
        opacity: 0;
        transform: scale(0.8);
    }
    50% {
        opacity: 1;
        transform: scale(1.2);
    }
    100% {
        transform: scale(1);
    }
}
</style>
